import { Controller } from "@hotwired/stimulus"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// Gli invii lunghi della scheda «Fatture» (pages/Rendicontazione.js, 31a5bd1): «Carica fatture» (busy: pulsante fermo con la
// rotella, alla fine l'input torna vuoto: finally dell'originale) e «Proponi le voci con l'AI» (aiBusy). Il server risponde
// con Turbo Stream (pannelli riscritti e toast). Come nell'originale la richiesta continua anche se si lascia la pagina:
// finche' non risponde le visite Turbo si fermano (lib/visite_trattenute.js) e l'ultima riparte alla fine. Una risposta
// d'errore che non e' un Turbo Stream (500, pagina del proxy) non diventa la pagina: toast col testo `errore`.
// <div class="contents group" data-controller="invio-rendicontazione" data-invio-rendicontazione-errore-value="…"
//      data-action="turbo:submit-start->invio-rendicontazione#inizio turbo:before-fetch-response->invio-rendicontazione#risposta turbo:submit-end->invio-rendicontazione#fine">
const STREAM = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["form", "input"]
  static values = { errore: String }

  connect() {
    this.visite = new VisiteTrattenute()
  }

  // il pannello riscritto stacca il controller: l'eventuale visita trattenuta riparte
  disconnect() {
    const url = this.visite.rilascia()
    if (url) riparti(url)
  }

  scegli() {
    if (this.element.getAttribute("aria-busy") === "true") return
    this.inputTarget.click()
  }

  invia() {
    if (this.inputTarget.files.length) this.formTarget.requestSubmit()
  }

  inizio(event) {
    if (event.target !== this.formTarget) return
    this.element.setAttribute("aria-busy", "true")
    this.visite.trattieni()
  }

  risposta(event) {
    if (event.target !== this.formTarget) return
    this.visite.lascia()
    const r = event.detail.fetchResponse
    if (r && !r.succeeded && !(r.contentType || "").startsWith(STREAM)) event.preventDefault()
  }

  fine(event) {
    if (event.target !== this.formTarget) return
    this.element.removeAttribute("aria-busy")
    if (this.hasInputTarget) this.inputTarget.value = ""
    const url = this.visite.rilascia()
    const { success, fetchResponse } = event.detail
    if (!success && !(fetchResponse?.contentType || "").startsWith(STREAM)) window.toast?.error?.(this.erroreValue)
    if (url) riparti(url)
  }
}
